module.exports = "/_next/static/images/motive-bg-6d2054cce2da8578cb2c46edeb1770ed.svg";